export default __webpack_public_path__ + "static/media/featured4.bd99cba3.png";